import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGRadioGroup, NGRadioGroupProps } from "../../../../newcomponents/radioGroup";

interface FormNGRadioGroupProps extends Omit<NGRadioGroupProps, "value" | "onChange" | "onBlur"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
}

export const FormNGRadioGroup = ({ name, control, rules, ...props }: FormNGRadioGroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <NGRadioGroup {...props} {...field} errorMessage={fieldState.error?.message} />
      )}
    />
  );
};
